<template>
    <div></div>
</template>

<script>
    import {SET_BREADCRUMB} from "@/core/services/store/breadcrumbs.module";

    export default {
        name: "SystemSettings",
        data() {
            return {
                userData: this.$store.getters.getUserData,
            }
        },
        mounted() {
            this.$store.dispatch(SET_BREADCRUMB, [
                {title: "Сервис", route: "system-settings"},
                {title: "Настройки системы"}
            ]);
        }
    }
</script>

<style scoped>

</style>